import { COUNTRY_CODES } from '@Saral-Influencer-Marketing/saral-utils/dist/constants/country';
import CustomSelect from '../../common/CustomSelect/CustomSelect';
import { getCountryFlag } from '../helpers/challengeCopy';
import styles from './ApplicationCountrySelect.module.css';

type ApplicationCountrySelectProps = {
  value: string;
  setValue: (value: string) => void;
  placeholder: string;
  hasError?: boolean;
};

export default function ApplicationCountrySelect({
  value,
  setValue,
  placeholder,
  hasError = false,
}: ApplicationCountrySelectProps) {
  const selectedCountry = COUNTRY_CODES.find((country) => country.name === value);

  return (
    <CustomSelect
      labelClassName={`${styles.trigger} ${hasError ? styles.triggerError : ''}`}
      selectLabel={
        <span className={`${styles.triggerText} ${selectedCountry ? styles.triggerTextSelected : ''}`}>
          {selectedCountry?.name || value || placeholder}
        </span>
      }
      dropDownElement={(setOpened, width) => (
        <div className={styles.menu} style={{ width }}>
          {COUNTRY_CODES.map((country) => (
            <button
              type="button"
              key={country.code}
              className={`${styles.option} ${country.name === value ? styles.optionSelected : ''}`}
              onClick={() => {
                setValue(country.name);
                setOpened(false);
              }}
            >
              {`${getCountryFlag(country.code)}  ${country.name}`}
            </button>
          ))}
        </div>
      )}
    />
  );
}
